import { backend, fetchBase, Geo } from '../lib/backend';
import { ColumnDef, Report } from '../lib/types';
import { mapObjectOntoTableauStruct } from '../lib/utils';

const columns: ColumnDef[] = [
  {
    name: "equipment_id",
    type: tableau.dataTypeEnum.string,
    alias: "Eqiupment ID",
    description: "Equipment ID",
  },
  {
    name: "equipment_name",
    type: tableau.dataTypeEnum.string,
    alias: "Equipment Name",
    description: "Equipment Name"
  },
  {
    name: "consumption",
    type: tableau.dataTypeEnum.float,
    alias: "Fuel Consumption",
    description: "Total fuel consumed"
  },
  {
    name: "distance",
    type: tableau.dataTypeEnum.float,
    alias: "Distance (KM)",
    description: "Total distance covered"
  },
  {
    name: "telematics_hours",
    type: tableau.dataTypeEnum.float,
    alias: "Telematics Hours",
    description: "Telematics Hours"
  }
];


const getReport = async () => {

  var connectionData_1 = tableau.connectionData ? JSON.parse(tableau.connectionData) : {};
  var geo = (connectionData_1.geo || "uae") as Geo;
  var account = (connectionData_1.account || "");

  const url = `/app/reports/sync?report_type=json`;

  let equipments = await backend.getEquipmentsByAccount({
    accountId: account,
    limit: 500,
  }, tableau.password, geo)
  let body = {
    "equipmentIds": equipments.map(a => a.id),
    "startDate": new Date(new Date().getTime() - (1000 * 60 * 60 * 24 * 7)).toString(),
    "endDate": new Date().toString(),
    "reportType": "DailyFuel",
    "formatType": "json",
    "groupId": ""
  }
  var myHeaders = { "Content-Type": "application/json" };

  const options: RequestInit = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(body)
  };
  let res = await fetchBase(url, options, tableau.password, geo);
  const tableData = mapObjectOntoTableauStruct(res, columns);
  return tableData;
}

export const daily_fuel_report: Report = {
  id: 'DailyFuelReport',
  alias: 'Daily Fuel Report',
  columns,
  get: getReport
};